<p-table
  [value]="datas"
  [lazy]="false"
  [paginator]="false"
  [rowHover]="false"
  [resizableColumns]="true"
  [class.no-zebra-shading]="true"
  #dtCards
>
  <ng-template pTemplate="header">
    <tr>
      <th>Service</th>
      <th>Vehicle Classification</th>
      <th>Callout Charge</th>
      <th *ngIf="!useBanding">Included Miles</th>
      <th *ngIf="!useBanding">Included Miles Fixed</th>
      <th *ngIf="!useBanding">£ per mile</th>
      <th *ngIf="!useBanding">Band 2: Lower Mileage Threshold</th>
      <th *ngIf="!useBanding">Band 2: £ per mile</th>
      <th *ngIf="!useBanding">Band 3: Lower Mileage</th>
      <th *ngIf="!useBanding">Band 3: £ per mile</th>
      <th *ngIf="useBanding">Band Prices</th>
      <th>£ per vehicle</th>
      <th>£ per hour</th>
      <th>£ per job</th>
      <th>Charging Rate</th>
      <th>Waiting Rate</th>
      <th>Inspection Charge</th>
      <th>Expense Inclusivity</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-data let-ri="rowIndex">
    <tr>
      <td>
        <span>{{
          data.serviceCard.serviceTypeName +
            (data.serviceCard.notes ? ' (' + data.serviceCard.notes + ')' : '')
        }}</span>
      </td>

      <td>
        {{
          (data.serviceCard.minWeight > 0 ? data.serviceCard.minWeight + 't' : '') +
            (data.serviceCard.maxWeight > 0
              ? data.serviceCard.minWeight > 0
                ? ' - ' + data.serviceCard.maxWeight + 't'
                : 'Less than ' + data.serviceCard.maxWeight + 't'
              : data.serviceCard.minWeight > 0
              ? '+'
              : 'All')
        }}
      </td>

      <td style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div
              *ngIf="data.pricing.callOut"
              [class.no-value]="data.pricing.callOut == null || data.pricing.callOut < 0"
              [class.editable-column]="!pricesReadonly"
            >
              {{
                to2Digits(data.pricing.callOut ? data.pricing.callOut : 0)
                  | currency : 'GBP' : 'symbol'
              }}
            </div>
            <i *ngIf="!data.pricing.callOut" style="color: lightgray" class="fa ui-icon-clear"></i>
          </ng-template>
          <ng-template pTemplate="input">
            <input
              pInputText
              [(ngModel)]="data.pricing.callOut"
              (keydown)="onRatecardPriceKeyDown($event, data, 'callOut')"
              (keyup)="inputHelper.fixDigits($event.target)"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onValueChanged(data, 'callOut', ri)"
              [disabled]="pricesReadonly"
              class="inline-textinput-number"
              maxlength="6"
            />
          </ng-template>
        </p-cellEditor>
      </td>

      <td *ngIf="!useBanding" style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input
              pInputText
              [(ngModel)]="data.pricing.includedMiles"
              (keydown)="onRatecardPriceKeyDown($event, data, { field: 'includedMiles' })"
              (keyup)="inputHelper.fixDigits($event.target)"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onValueChanged(data, 'includedMiles', ri)"
              [disabled]="pricesReadonly"
              class="inline-textinput-number"
              maxlength="6"
            />
          </ng-template>
          <ng-template pTemplate="output">
            <div *ngIf="data.pricing.includedMiles">
              {{ data.pricing.includedMiles }}
            </div>
            <i
              *ngIf="!data.pricing.includedMiles"
              style="color: lightgray"
              class="fa ui-icon-clear"
            ></i>
          </ng-template>
        </p-cellEditor>
      </td>
      <td *ngIf="!useBanding" style="text-align: center" [pEditableColumn]="data">
        <p-checkbox
          [(ngModel)]="data.pricing.includedMilesFixed"
          binary="true"
          appendTo="body"
          [disabled]="data.pricing.includedMiles < 1 || pricesReadonly"
        ></p-checkbox>
      </td>
      <td *ngIf="!useBanding" style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div *ngIf="emptyBanding(data.pricing.bandings)">
              <div *ngIf="data.pricing.perMile" [class.editable-column]="!pricesReadonly">
                {{
                  to2Digits(data.pricing.perMile ? data.pricing.perMile : 0)
                    | currency : 'GBP' : 'symbol'
                }}
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="input">
            <div *ngIf="emptyBanding(data.pricing.bandings)">
              <input
                pInputText
                [(ngModel)]="data.pricing.perMile"
                (keydown)="onRatecardPriceKeyDown($event, data, { field: 'perMile' })"
                (keyup)="inputHelper.fixDigits($event.target)"
                [ngModelOptions]="{ standalone: true }"
                (blur)="onValueChanged(data, 'perMile', ri)"
                [disabled]="pricesReadonly"
                appendTo="body"
                class="inline-textinput-number"
                maxlength="6"
              />
              <!--<i
                                  *ngIf="!data.pricing.perMile"
                                  style="color: lightgray"
                                  class="fa ui-icon-clear"
                                ></i>-->
            </div>
          </ng-template>
        </p-cellEditor>
      </td>

      <td *ngIf="!useBanding" [pEditableColumn]="data" style="text-align: center">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div
              *ngIf="data.pricing.band2LowerMileageThreshold"
              [class.editable-column]="!pricesReadonly"
              [class.no-value]="isBand2Invalid(data.pricing)"
            >
              {{
                to2Digits(
                  data.pricing.band2LowerMileageThreshold
                    ? data.pricing.band2LowerMileageThreshold
                    : 0
                )
              }}
            </div>
            <i
              *ngIf="!data.pricing.band2LowerMileageThreshold"
              style="color: lightgray"
              class="fa ui-icon-clear"
            ></i>
          </ng-template>

          <ng-template pTemplate="input">
            <input
              pInputText
              [(ngModel)]="data.pricing.band2LowerMileageThreshold"
              (keydown)="
                onRatecardPriceKeyDown($event, data, { field: 'band2LowerMileageThreshold' })
              "
              (keyup)="inputHelper.fixDigits($event.target)"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onValueChanged(data, 'band2LowerMileageThreshold', ri)"
              [disabled]="pricesReadonly"
              appendTo="body"
              class="inline-textinput-number"
            />
          </ng-template>
        </p-cellEditor>
      </td>
      <td *ngIf="!useBanding" style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div [class.editable-column]="!pricesReadonly" *ngIf="data.pricing.band2PerMile">
              {{
                to2Digits(data.pricing.band2PerMile ? data.pricing.band2PerMile : 0)
                  | currency : 'GBP' : 'symbol'
              }}
            </div>
            <i
              *ngIf="!data.pricing.band2PerMile"
              style="color: lightgray"
              class="fa ui-icon-clear"
            ></i>
          </ng-template>
          <ng-template pTemplate="input">
            <input
              pInputText
              [(ngModel)]="data.pricing.band2PerMile"
              (keydown)="onRatecardPriceKeyDown($event, data, { field: 'band2PerMile' })"
              (keyup)="inputHelper.fixDigits($event.target)"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onValueChanged(data, 'band2PerMile', ri)"
              [disabled]="pricesReadonly"
              appendTo="body"
              class="inline-textinput-number"
            />
          </ng-template>
        </p-cellEditor>
      </td>
      <td *ngIf="!useBanding" style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div
              *ngIf="data.pricing.band3LowerMileage"
              [class.editable-column]="!pricesReadonly"
              [class.no-value]="isBand2Invalid(data.pricing) || isBand3Invalid(data.pricing)"
            >
              {{ to2Digits(data.pricing.band3LowerMileage ? data.pricing.band3LowerMileage : 0) }}
            </div>
            <i
              *ngIf="!data.pricing.band3LowerMileage"
              style="color: lightgray"
              class="fa ui-icon-clear"
            ></i>
          </ng-template>

          <ng-template pTemplate="input">
            <input
              pInputText
              [(ngModel)]="data.pricing.band3LowerMileage"
              (keydown)="onRatecardPriceKeyDown($event, data, { field: 'band3LowerMileage' })"
              (keyup)="inputHelper.fixDigits($event.target)"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onValueChanged(data, 'band3LowerMileage', ri)"
              [disabled]="pricesReadonly"
              appendTo="body"
              class="inline-textinput-number"
            />
          </ng-template>
        </p-cellEditor>
      </td>
      <td *ngIf="!useBanding" style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div *ngIf="data.pricing.band3PerMile" [class.editable-column]="!pricesReadonly">
              {{
                to2Digits(data.pricing.band3PerMile ? data.pricing.band3PerMile : 0)
                  | currency : 'GBP' : 'symbol'
              }}
            </div>
            <i
              *ngIf="!data.pricing.band3PerMile"
              style="color: lightgray"
              class="fa ui-icon-clear"
            ></i>
          </ng-template>

          <ng-template pTemplate="input">
            <input
              pInputText
              [(ngModel)]="data.pricing.band3PerMile"
              (keydown)="onRatecardPriceKeyDown($event, data, { field: 'band3PerMile' })"
              (keyup)="inputHelper.fixDigits($event.target)"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onValueChanged(data, 'band3PerMile', ri)"
              [disabled]="pricesReadonly"
              appendTo="body"
              class="inline-textinput-number"
              maxlength="6"
            />
          </ng-template>
        </p-cellEditor>
      </td>
      <td *ngIf="useBanding" style="text-align: center">
        <div>
          <button
            type="button"
            pButton
            label="Edit Prices"
            (click)="editBanding(data)"
            [disabled]="agreementBandings.length == 0"
          ></button>
        </div>
      </td>

      <td style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div
              *ngIf="data.pricing.perVehicle"
              [class.no-value]="data.pricing.perVehicle == null || data.pricing.perVehicle < 0"
              [class.editable-column]="!pricesReadonly"
            >
              {{
                to2Digits(data.pricing.perVehicle ? data.pricing.perVehicle : 0)
                  | currency : 'GBP' : 'symbol'
              }}
            </div>
            <i
              *ngIf="!data.pricing.perVehicle"
              style="color: lightgray"
              class="fa ui-icon-clear"
            ></i>
          </ng-template>

          <ng-template pTemplate="input">
            <input
              pInputText
              [(ngModel)]="data.pricing.perVehicle"
              (keydown)="onRatecardPriceKeyDown($event, data, { field: 'perVehicle' })"
              (keyup)="inputHelper.fixDigits($event.target)"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onValueChanged(data, 'perVehicle', ri)"
              [disabled]="pricesReadonly"
              appendTo="body"
              class="inline-textinput-number"
              maxlength="6"
            />
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div
              *ngIf="data.pricing.ratePerHr"
              [class.no-value]="data.pricing.ratePerHr == null || data.pricing.ratePerHr < 0"
              [class.editable-column]="!pricesReadonly"
            >
              {{
                to2Digits(data.pricing.ratePerHr ? data.pricing.ratePerHr : 0)
                  | currency : 'GBP' : 'symbol'
              }}
            </div>
            <i
              *ngIf="!data.pricing.ratePerHr"
              style="color: lightgray"
              class="fa ui-icon-clear"
            ></i>
          </ng-template>

          <ng-template pTemplate="input">
            <input
              pInputText
              [(ngModel)]="data.pricing.ratePerHr"
              (keydown)="onRatecardPriceKeyDown($event, data, { field: 'ratePerHr' })"
              (keyup)="inputHelper.fixDigits($event.target)"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onValueChanged(data, 'ratePerHr', ri)"
              [disabled]="pricesReadonly"
              appendTo="body"
              class="inline-textinput-number"
              maxlength="6"
            />
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div
              *ngIf="data.pricing.perJob"
              [class.no-value]="data.pricing.perJob == null || data.pricing.perJob < 0"
              [class.editable-column]="!pricesReadonly"
            >
              {{
                to2Digits(data.pricing.perJob ? data.pricing.perJob : 0)
                  | currency : 'GBP' : 'symbol'
              }}
            </div>
            <i *ngIf="!data.pricing.perJob" style="color: lightgray" class="fa ui-icon-clear"></i>
          </ng-template>

          <ng-template pTemplate="input">
            <input
              pInputText
              [(ngModel)]="data.pricing.perJob"
              (keydown)="onRatecardPriceKeyDown($event, data, 'perJob')"
              (keyup)="inputHelper.fixDigits($event.target)"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onValueChanged(data, 'perJob', ri)"
              [disabled]="pricesReadonly"
              appendTo="body"
              class="inline-textinput-number"
              maxlength="6"
            />
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div
              *ngIf="data.pricing.chargingTimeRate"
              [class.no-value]="
                data.pricing.chargingTimeRate == null || data.pricing.chargingTimeRate < 0
              "
              [class.editable-column]="!pricesReadonly"
            >
              {{
                to2Digits(data.pricing.chargingTimeRate ? data.pricing.chargingTimeRate : 0)
                  | currency : 'GBP' : 'symbol'
              }}
            </div>
            <i
              *ngIf="!data.pricing.chargingTimeRate"
              style="color: lightgray"
              class="fa ui-icon-clear"
            ></i>
          </ng-template>

          <ng-template pTemplate="input">
            <input
              pInputText
              [(ngModel)]="data.pricing.chargingTimeRate"
              (keydown)="onRatecardPriceKeyDown($event, data, 'chargingTimeRate')"
              (keyup)="inputHelper.fixDigits($event.target)"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onValueChanged(data, 'chargingTimeRate', ri)"
              [disabled]="pricesReadonly"
              appendTo="body"
              class="inline-textinput-number"
              maxlength="6"
            />
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div
              *ngIf="data.pricing.waitingTimeRate"
              [class.no-value]="
                data.pricing.waitingTimeRate == null || data.pricing.waitingTimeRate < 0
              "
              [class.editable-column]="!pricesReadonly"
            >
              {{
                to2Digits(data.pricing.waitingTimeRate ? data.pricing.waitingTimeRate : 0)
                  | currency : 'GBP' : 'symbol'
              }}
            </div>
            <i
              *ngIf="!data.pricing.waitingTimeRate"
              style="color: lightgray"
              class="fa ui-icon-clear"
            ></i>
          </ng-template>

          <ng-template pTemplate="input">
            <input
              pInputText
              [(ngModel)]="data.pricing.waitingTimeRate"
              (keydown)="onRatecardPriceKeyDown($event, data, 'waitingTimeRate')"
              (keyup)="inputHelper.fixDigits($event.target)"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onValueChanged(data, 'waitingTimeRate', ri)"
              [disabled]="pricesReadonly"
              appendTo="body"
              class="inline-textinput-number"
              maxlength="6"
            />
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div
              *ngIf="data.pricing.inspectionCharge"
              [class.no-value]="
                data.pricing.inspectionCharge == null || data.pricing.inspectionCharge < 0
              "
              [class.editable-column]="!pricesReadonly"
            >
              {{
                to2Digits(data.pricing.inspectionCharge ? data.pricing.inspectionCharge : 0)
                  | currency : 'GBP' : 'symbol'
              }}
            </div>
            <i
              *ngIf="!data.pricing.inspectionCharge"
              style="color: lightgray"
              class="fa ui-icon-clear"
            ></i>
          </ng-template>

          <ng-template pTemplate="input">
            <input
              pInputText
              [(ngModel)]="data.pricing.inspectionCharge"
              (keydown)="onRatecardPriceKeyDown($event, data, 'inspectionCharge')"
              (keyup)="inputHelper.fixDigits($event.target)"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onValueChanged(data, 'inspectionCharge', ri)"
              [disabled]="pricesReadonly"
              class="inline-textinput-number"
              maxlength="6"
            />
          </ng-template>
        </p-cellEditor>
      </td>

      <td style="text-align: center" [pEditableColumn]="data">
        <p-cellEditor>
          <ng-template pTemplate="output">
            <div *ngIf="data.pricing.inclusivityType" [class.editable-column]="!pricesReadonly">
              {{ data.pricing.inclusivityType.name }}
            </div>
            <i
              *ngIf="!data.pricing.inclusivityType"
              style="color: lightgray"
              class="fa ui-icon-clear"
            ></i>
          </ng-template>

          <ng-template pTemplate="input">
            <p-dropdown
              [options]="inclusivityTypes"
              [(ngModel)]="data.pricing.inclusivityType"
              optionLabel="name"
              [dataKey]="'id'"
              placeholder="Select Type"
              appendTo="body"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="onValueChanged(data, 'inclusivityType', ri)"
              [disabled]="pricesReadonly"
            ></p-dropdown>
          </ng-template>
        </p-cellEditor>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  header="Band Prices"
  [(visible)]="priceBandingDialogVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '450px' }"
>
  <form #addBandingForm="ngForm">
    <div class="ui-grid">
      <p-table
        [value]="dlgBandings"
        #dtBandings
        [lazy]="false"
        [paginator]="false"
        [rowHover]="false"
        [class.no-zebra-shading]="true"
        [responsive]="true"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Lower Threshold (Miles)</th>
            <th>Price</th>
            <th>Is Fixed Price</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-band>
          <tr [pSelectableRow]="band">
            <td>
              <span>{{ band.from }}</span>
            </td>
            <td>
              <p-spinner
                [size]="8"
                [min]="0"
                [step]="0.01"
                [(ngModel)]="band.price"
                thousandSeparator=""
                (onBlur)="onBandingCellBlur($event, band, band.price)"
                [ngModelOptions]="{ standalone: true }"
                class="inline-grid-number"
                [maxlength]="6"
                [formatInput]="false"
              ></p-spinner>
            </td>
            <td class="align-center">
              <p-checkbox
                [(ngModel)]="band.isFixedPrice"
                [ngModelOptions]="{ standalone: true }"
                binary="true"
              ></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-grid-row" style="float: right">
      <button
        type="button"
        class="green-btn"
        pButton
        icon="fa ui-icon-check"
        (click)="dlgSaveBanding()"
        label="Save"
        [disabled]="!priceBandingValid(dlgBandings)"
      ></button>
      <button
        type="button"
        icon="fa ui-icon-trash"
        pButton
        (click)="dlgDeleteBanding()"
        label="Clear"
        class="ui-button-danger"
        [disabled]="emptyBanding(dlgBandings)"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Close"
        (click)="priceBandingDialogVisible = false"
      ></button>
    </div>
  </form>
</p-dialog>
<ng-template #loading>Loading...</ng-template>
